import { useContext, useState, useEffect } from "react"
import _ from "lodash"
import { Field, useFormikContext } from "formik"

import { FormContext } from "../../../context/formContext"
import { InputNumber } from "primereact/inputnumber"

import styles from "../../../styles/Form.module.css"

import fieldVisibility from "../../../helpers/fieldVisibility"

export default function ParticipantAddressLivesLength({ field, block, index }) {
  const [years, setYears] = useState(0)
  const [months, setMonths] = useState(0)
  const formik = useFormikContext()

  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    let length = formik?.getFieldProps(field?.field_name)?.value
    const totalYears = Math.floor(length / 12)
    setYears(totalYears)
    const totalMonths = length % 12
    setMonths(totalMonths)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)
  }, [])

  useEffect(() => {
    const livesLength = years * 12 + months
    if (formik.values[field.field_name] !== livesLength) {
      formik.setFieldValue(field.field_name, livesLength)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [years, months])

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => {
            return (
              <div style={{ display: "flex", gap: 10, flexDirection: "row" }}>
                <div>
                  <label style={{ display: "flex" }}>Years:</label>
                  <InputNumber
                    id="years"
                    name="years"
                    value={years}
                    showButtons
                    min={0}
                    pattern="\d+"
                    onChange={({ value }) => {
                      const newValue = value === null ? 0 : value
                      setYears(newValue)
                    }}
                    disabled={isDisabled}
                    onBlur={formikField.onBlur}
                  />
                </div>
                <div>
                  <label style={{ display: "flex" }}>Months:</label>
                  <InputNumber
                    id="months"
                    name="months"
                    value={months}
                    showButtons
                    min={0}
                    max={11}
                    pattern="\d+"
                    onChange={({ value }) => {
                      const newValue = value === null ? 0 : value
                      setMonths(newValue)
                    }}
                    disabled={isDisabled}
                    onBlur={formikField.onBlur}
                  />
                </div>
              </div>
            )
          }}
        </Field>
      </div>
    </div>
  )
}
